import SurveyService, {
    getSectorById,
    setSurveyCycleStatus,
    getAllSectors,
    createSurveyCycle,
    getAllSurveyCycles,
    getSurveyCycleById,
    getSurveyCycleByOrganisationStateId,
    getQuestionnaireBySurveyCycleIdAndSectorId,
    getQuestionnaireIdBySurveyCycleIdAndSectorId,
    getQuestionnaireByOrganisationStateId,
    saveRecordsDispatchList,
    copyRegisterOrganisations,
    copyRegisterOrganisationContacts
} from './SurveyService';

export default {
    SurveyService, getSectorById, setSurveyCycleStatus, getAllSectors, createSurveyCycle, getAllSurveyCycles, getSurveyCycleById, getSurveyCycleByOrganisationStateId, getQuestionnaireBySurveyCycleIdAndSectorId, getQuestionnaireIdBySurveyCycleIdAndSectorId, getQuestionnaireByOrganisationStateId, saveRecordsDispatchList, copyRegisterOrganisations, copyRegisterOrganisationContacts }